"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginTestUsersResponseToJSON = exports.LoginTestUsersResponseFromJSONTyped = exports.LoginTestUsersResponseFromJSON = void 0;
var _1 = require("./");
function LoginTestUsersResponseFromJSON(json) {
    return LoginTestUsersResponseFromJSONTyped(json, false);
}
exports.LoginTestUsersResponseFromJSON = LoginTestUsersResponseFromJSON;
function LoginTestUsersResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userTokens': (json['userTokens'].map(_1.LoginTestUsersResponseUserTokensFromJSON)),
    };
}
exports.LoginTestUsersResponseFromJSONTyped = LoginTestUsersResponseFromJSONTyped;
function LoginTestUsersResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userTokens': (value.userTokens.map(_1.LoginTestUsersResponseUserTokensToJSON)),
    };
}
exports.LoginTestUsersResponseToJSON = LoginTestUsersResponseToJSON;
